import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import messageResource from '../../messageResource'

export default class DeleteCustomerPopupConfirmationDialog extends DeleteConfirmationDialog {
    constructor($container, cancelHandler, deleteHandler, visibleProjectCount, isCustomerActive) {
        super($container, cancelHandler, deleteHandler);
        this.visibleProjectCount = visibleProjectCount;
        this.isCustomerActive = isCustomerActive;
    }

    titleText()
    {
        var withProjects = "";
        if (this.visibleProjectCount > 0)
        {
            var projectsCountText = messageResource.getMessage(this.isCustomerActive ? "common.active_multiple" : "common.archived_multiple",
                                                               [this.visibleProjectCount]);
            withProjects = messageResource.getMessage("delete.confirm.dialog.cp.popup.along_with_projects", [projectsCountText]);
        }
        return messageResource.getMessage("delete.confirm.dialog.cp.popup.customer", [this.state.entityName, withProjects]);
    }

    firstOrangeSentence()
    {
        return messageResource.getMessage("delete.confirm.dialog.cp.popup.first_orange_sentence", [messageResource.getMessage("common.Customer")]);
    }

    secondOrangeSentence()
    {
        return messageResource.getMessage(this.hasTimeTrack() ?
                                          "delete.confirm.dialog.cp.second_orange_sentence.please_confirm_actions" :
                                          "delete.confirm.dialog.cp.second_orange_sentence.please_confirm");
    }

    removeEntitiesPointText()
    {
        var pronoun = messageResource.getMessage("delete.confirm.dialog.their");
        return messageResource.getMessage("delete.confirm.dialog.cp.remove_entities_point_text.customers_and_projects",
                                          [messageResource.getMessage("common.customer"), pronoun]);
    }

    removeTimeTrackPointText()
    {
        return messageResource.getMessage("delete.confirm.dialog.cp.remove_time_track_point_text")
    }

    deleteButtonText()
    {
        if (this.hasTimeTrack())
            return messageResource.getMessage("delete.confirm.dialog.delete_task_with_entries");
        else
            return messageResource.getMessage("delete.confirm.dialog.cp.delete_button_text.no_tt")
    }
}


// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/DeleteCustomerPopupConfirmationDialog.js